import React, { useState,useEffect } from 'react'
import { Logo } from '../../components';
import  Modal  from '../../components/Modal/Modal';
import { FormattedMessage} from '../../util/reactIntl';
import css from './EditListingPhotosForm.css';
import { Button } from '../../components';



const InvalidImageModal=(props)=>{
    const [showModal, setShowModal]=useState(false);
    useEffect(()=>{
        setShowModal(props.showModal)
    },[props.showModal,showModal])

    return(
        <Modal
        id="AuthenticationPage.tos" 
        isOpen={showModal}
        onClose={props.handleClose}
        onManageDisableScrolling={() => setShowModal(!showModal)}
        usePortal={true}
      >
        <Logo
          format="desktop"
          alt={props.intl.formatMessage({ id: 'TopbarDesktop.logo' })}
          style={{ marginBottom: '7px' }}
        />
        <div className={css.textWrapper}>
          <FormattedMessage id="EditListingPhotosForm.invalidImage"/>
        </div>
        <Button 
                onClick={props.handleClose}
          	    style={{width:"100%", height:"30%", marginTop:"50px"}}
                className={css.submitButton}
              >
        <FormattedMessage id="EditListingPhotosForm.ok" />
              </Button>
      </Modal>
    )
}
export default InvalidImageModal;